const TATWEEL = String.fromCodePoint(0x0640);
const COMBINING_MARKS = /\p{Mn}/gu;

/**
 * Fold text for matching: case, Arabic diacritics and tatweel, alef variants, taa marbuta and
 * alef maqsura, so "احمد" finds "أحمد" and "مدرسه" finds "مدرسة".
 */
export function normalizeSearch(text: string): string {
  return text
    .normalize("NFKD")
    .replace(COMBINING_MARKS, "")
    .replaceAll(TATWEEL, "")
    .replace(/[أإآ]/g, "ا")
    .replaceAll("ة", "ه")
    .replaceAll("ى", "ي")
    .toLowerCase()
    .trim();
}

export function matchesSearch(query: string, ...fields: string[]): boolean {
  const needle = normalizeSearch(query);
  return needle === "" || fields.some((field) => normalizeSearch(field).includes(needle));
}
